var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54318 6.29109C9.54606 6.51916 9.3635 6.70639 9.13543 6.70927L1.7061 6.80307C1.47803 6.80595 1.2908 6.62339 1.28792 6.39532L1.28501 6.16459C1.28213 5.93652 1.46469 5.74929 1.69276 5.74641L9.12209 5.65261C9.35016 5.64973 9.53739 5.83229 9.54027 6.06036L9.54318 6.29109Z",
    fill: "#DB3939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12209 5.65261L9.13099 6.35756L9.12209 5.65261ZM9.54027 6.06036L8.83532 6.06926L9.54027 6.06036ZM9.13543 6.70927L9.14433 7.41421L9.13543 6.70927ZM9.54318 6.29109L8.83823 6.29999L9.54318 6.29109ZM1.715 7.50801L9.14433 7.41421L9.12653 6.00432L1.6972 6.09812L1.715 7.50801ZM0.580066 6.17349L0.582979 6.40422L1.99287 6.38642L1.98995 6.15569L0.580066 6.17349ZM9.11319 4.94767L1.68386 5.04147L1.70166 6.45136L9.13099 6.35756L9.11319 4.94767ZM10.2481 6.28219L10.2452 6.05146L8.83532 6.06926L8.83823 6.29999L10.2481 6.28219ZM9.13099 6.35756C8.96973 6.35959 8.83736 6.23052 8.83532 6.06926L10.2452 6.05146C10.2374 5.43406 9.73059 4.93987 9.11319 4.94767L9.13099 6.35756ZM1.98995 6.15569C1.99199 6.31695 1.86291 6.44932 1.70166 6.45136L1.68386 5.04147C1.06646 5.04927 0.572271 5.55609 0.580066 6.17349L1.98995 6.15569ZM9.14433 7.41421C9.76173 7.40641 10.2559 6.89959 10.2481 6.28219L8.83823 6.29999C8.8362 6.13873 8.96527 6.00636 9.12653 6.00432L9.14433 7.41421ZM1.6972 6.09812C1.85846 6.09609 1.99083 6.22516 1.99287 6.38642L0.582979 6.40422C0.590775 7.02162 1.0976 7.51581 1.715 7.50801L1.6972 6.09812Z",
    fill: "#DB3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.bb1ae71a82874acdca02f451049a8d3e.svg";
export { ForwardRef as ReactComponent };